export default __webpack_public_path__ + "static/media/presentation.cbc7803f.pptx";